import axios from "axios";

const url = process.env.REACT_APP_API_URL_NONLALIN
const contentType = 'application/json'

export default class NonlalinService {
    listNonlalinPerUpt(nomorAju, npwpTrader, kdUpt, status, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (kdUpt !== null) {
            param += '&kdUpt=' + kdUpt
        }
        if (status !== null) {
            param += '&status=' + status
        }
        if (npwpTrader !== null) {
            param += '&npwpTrader=' + npwpTrader
        }
        return axios.get(url + '/nonlalin-upt?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listNonlalinPerUptOnProcess(nomorAju, npwpTrader, kdUpt, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (kdUpt !== null) {
            param += '&kdUpt=' + kdUpt
        }
        if (npwpTrader !== null) {
            param += '&npwpTrader=' + npwpTrader
        }
        return axios.get(url + '/nonlalin-upt-on-process?page=' + page + '&size=' + size + param + '&status=000&status=120&sort=tanggalAju,desc', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listNonlalinPerUptOnProcessLab(nomorAju, npwpTrader, kdUpt, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (kdUpt !== null) {
            param += '&kdUpt=' + kdUpt
        }
        if (npwpTrader !== null) {
            param += '&npwpTrader=' + npwpTrader
        }
        return axios.get(url + '/nonlalin-upt-on-process-by-layanan?page=' + page + '&size=' + size + param + '&maksudKegiatan=1&maksudKegiatan=7&maksudKegiatan=3&maksudKegiatan=4&status=000&status=010&status=020&status=120&sort=tanggalAju,desc', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listNonlalinPerUptOnProcessLainnya(nomorAju, npwpTrader, kdUpt, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (kdUpt !== null) {
            param += '&kdUpt=' + kdUpt
        }
        if (npwpTrader !== null) {
            param += '&npwpTrader=' + npwpTrader
        }
        return axios.get(url + '/nonlalin-upt-on-process-by-layanan?page=' + page + '&size=' + size + param + '&maksudKegiatan=5&maksudKegiatan=6&status=000&status=010&status=020&status=120&sort=tanggalAju,desc', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listNonlalinPerUptOnProcessScanning(nomorAju, npwpTrader, kdUpt, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (kdUpt !== null) {
            param += '&kdUpt=' + kdUpt
        }
        if (npwpTrader !== null) {
            param += '&npwpTrader=' + npwpTrader
        }
        return axios.get(url + '/nonlalin-upt-on-process-by-layanan?page=' + page + '&size=' + size + param + '&maksudKegiatan=2&status=000&status=010&status=020&status=120&sort=tanggalAju,desc', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getNonlalinHeader(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/nonlalin-header/' + nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveNonlalinHeader(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/nonlalin-header', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteNonlalinHeader(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/nonlalin-header/' + nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    copyPermohonan(oldAju, newAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/copy-permohonan/' + oldAju + '/' + newAju, null, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listNonlalinDtlAll(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/nonlalin-dtl-all?nomorAju=' + nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getNonlalinDtlById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/nonlalin-dtl-by-id', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    saveNonlalinDtl(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/nonlalin-dtl', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteNonlalinDtl(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/nonlalin-dtl', {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            },
            data: jsonData
        })
    }

    listNonlalinDokAll(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/nonlalin-dok-all?nomorAju=' + nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getNonlalinDokById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/nonlalin-dok-by-id', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    saveNonlalinDok(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/nonlalin-dok', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteNonlalinDok(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/nonlalin-dok', {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            },
            data: jsonData
        })
    }

    listNonlalinKemasanAll(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/nonlalin-kemasan-all?nomorAju=' + nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getNonlalinKemasanById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/nonlalin-kemasan-by-id', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    saveNonlalinKemasan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/nonlalin-kemasan', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteNonlalinKemasan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/nonlalin-kemasan', {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            },
            data: jsonData
        })
    }

    listNonlalinStatusAll(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/nonlalin-status-all?nomorAju=' + nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveNonlalinStatus(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/nonlalin-status', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    listNonlalinPenugasanAll(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/penugasan-all?nomorAju=' + nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getNonlalinPenugasanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/penugasan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveNonlalinPenugasan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/penugasan', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteNonlalinPenugasanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/penugasan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listNonlalinPenugasanDetil(nomorAju, noTugas) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/penugasan-detil?nomorAJu=' + nomorAju + '&noTugas=' + noTugas, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveNonlalinPenugasanDetil(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/penugasan-detil', jsonData, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listRefNonlalinStatus(uraianStatus, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (uraianStatus !== null) {
            param += '&uraianStatus=' + uraianStatus
        }
        return axios.get(url + '/ref-status-nonlalin?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getRefNonlalinStatus(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ref-status-nonlalin/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveRefNonlalinStatus(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ref-status-nonlalin', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteRefNonlalinStatus(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ref-status-nonlalin/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listDisposisi(nmDisposisi, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nmDisposisi !== null) {
            param += '&nmDisposisi=' + nmDisposisi
        }
        return axios.get(url + '/disposisi?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getDisposisiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/disposisi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveDisposisi(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/disposisi', jsonData, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deleteDisposisiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/disposisi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listRefNonlalinMaksudKegiatan(urMaksudKegiatan, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (urMaksudKegiatan !== null) {
            param += '&urMaksudKegiatan=' + urMaksudKegiatan
        }
        return axios.get(url + '/maksud-kegiatan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getRefNonlalinMaksudKegiatanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/maksud-kegiatan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    nextSeriNonlalin(tableName, nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/next-seri-nonlalin?tableName=' + tableName + '&nomorAju=' + nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listNonlalinDtlPeriksaAll(nomorAju, seri) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/nonlalin-dtl-periksa-all?nomorAju=' + nomorAju + '&seri=' + seri, {
            headers: {
                'Authorization': Auth
            }
        })
    }
    
    listNonlalinDtlPeriksaAllByAju(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/nonlalin-dtl-periksa-all-by-aju?nomorAju=' + nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveNonlalinDtlPeriksa(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/nonlalin-dtl-periksa', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteNonlalinDtlPeriksa(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/nonlalin-dtl-periksa', {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            },
            data: jsonData
        })
    }

    nextSeriTarif(nomorAju, seri) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/next-seri-tarif-nonlalin-periksa?nomorAju=' + nomorAju + '&seri=' + seri, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getNonlalinBast(nomorAju, noTugas) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/bast-sample?nomorAju=' + nomorAju + '&noTugas=' + noTugas, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveNonlalinBast(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/bast-sample', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteNonlalinBast(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/bast-sample/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getNonlalinLhpHeader(nomorAju, nomorSpp) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/nonlalin-lhp-header?nomorAju=' + nomorAju + '&nomorSpp=' + nomorSpp, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveNonlalinLhpHeader(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/nonlalin-lhp-header', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteNonlalinLhpHeader(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/nonlalin-lhp-header/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listNonlalinLhpDetail(idLhp) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/nonlalin-lhp-detail-list/' + idLhp, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getNonlalinLhpDetailById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/nonlalin-lhp-detail/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveNonlalinLhpDetail(jsonData){
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/nonlalin-lhp-detail', jsonData, {
            headers: {
                'Authorization': Auth, 
                'Content-Type': contentType
            }
        })
    }

    deleteNonlalinLhpDetail(id){
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + 'nonlalin-lhp-detail/'+id, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }
}